import { createSlice } from "@reduxjs/toolkit";

let fakeData = [
  {
    "id": "lv999999-8888-7777-6666-555555555555",
    "name": "Front Desk & Hallway",
    "version": 1,
  },
];

// Detail data keyed by liveViewId — returned by the
// `.../settings/liveViews/{liveViewId}.read` API
const fakeDetailData = {
  "lv999999-8888-7777-6666-555555555555": {
    version: 1,
    name: "Front Desk, Hallway & Lobby",
    gridTemplate: 6,
    slots: [
      // Align with MOCK_DEVICES Cam-01 so View ▶ can stream in local/mock mode
      { slotIndex: 0, deviceId: "00:1C:27:27:97:BA" },
      { slotIndex: 1, deviceId: "cam-002" },
      { slotIndex: 2, deviceId: "cam-003" },
    ],
  },
};

const initialState = {
  data: [...fakeData],
  // Holds the last fetched view detail, wrapped in `{ data }` to mirror the
  // real websocket response shape (see useDataSourceManager `response?.data`)
  detail: { data: null },
};

export const liveViewsSlice = createSlice({
  name: "liveViews",
  initialState,
  reducers: {
    setLiveViewsData: (state) => {
      state.data = [...fakeData];
    },
    setLiveViewDetailData: (state, action) => {
      const liveViewId = action.payload?.liveViewId;
      const detail = fakeDetailData[liveViewId];

      state.detail = {
        data: detail ? { id: liveViewId, ...detail } : null,
      };
    },
    updateLiveViewData: (state, action) => {
      const liveViewId = action.payload?.liveViewId;
      const payload = action.payload?.data ?? {};

      if (!liveViewId) return;

      fakeDetailData[liveViewId] = {
        ...(fakeDetailData[liveViewId] ?? {}),
        ...payload,
      };

      const listIndex = fakeData.findIndex((item) => item.id === liveViewId);
      if (listIndex !== -1) {
        fakeData[listIndex] = {
          ...fakeData[listIndex],
          name: payload.name ?? fakeData[listIndex].name,
          version: payload.version ?? fakeData[listIndex].version,
        };
        state.data = [...fakeData];
      }

      state.detail = {
        data: { id: liveViewId, ...fakeDetailData[liveViewId] },
      };
    },
    deleteLiveViewData: (state, action) => {
      const liveViewId = action.payload?.liveViewId;

      if (!liveViewId) return;

      fakeData = fakeData.filter((item) => item.id !== liveViewId);
      delete fakeDetailData[liveViewId];

      state.data = [...fakeData];
      if (state.detail?.data?.id === liveViewId) {
        state.detail = { data: null };
      }
    },
    createLiveViewData: (state, action) => {
      const payload = action.payload?.data ?? {};
      const id = `lv-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      const detail = {
        version: 1,
        name: payload.name ?? "View",
        gridTemplate: payload.gridTemplate ?? 1,
        slots: payload.slots ?? [],
      };

      fakeDetailData[id] = detail;
      fakeData.push({ id, name: detail.name, version: 1 });
      state.data = [...fakeData];
      state.detail = { data: { id, ...detail } };
    },
  },
});

export const {
  setLiveViewsData,
  setLiveViewDetailData,
  updateLiveViewData,
  deleteLiveViewData,
  createLiveViewData,
} = liveViewsSlice.actions;

export default liveViewsSlice.reducer;
